import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=22d5e482&scoped=true&"
import script from "./TransactionsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransactionsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TransactionsTable.vue?vue&type=style&index=0&id=22d5e482&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5e482",
  null
  
)

export default component.exports